module.exports = __webpack_public_path__ + "static/img/mcgrath.66acc085.png";